import React, { FC, memo } from "react";
import { IM21QuoteBlock } from "@montana/models/generated/cms.interface";
import { RichText } from "@montana/shared/rich-text";
import { SvgIcon } from "@montana/shared/svg-icon";

export const M21QuoteBlock: FC<IM21QuoteBlock> = memo(({ quote, author, backgroundColorHex }: IM21QuoteBlock) => {

    if (!quote) {
        return null;
    }

    const textColorMatch = quote.match(/color: ([^;]+)/);

    return (
        <section className="quote-block">
            {backgroundColorHex && <div className="quote-block__bg" style={{ backgroundColor: backgroundColorHex }}></div>}
            <div className="quote-block__quote" style={(textColorMatch ? { color: textColorMatch[1] } : {})}>
                <SvgIcon className="quote-block__svg" iconName="quote" />
                <RichText className="quote-block__text" text={quote} />
                <div className="quote-block__author">{author}</div>
            </div>
        </section>
    )
});